import axios from 'axios'
import * as localData from '@/services/localData.js'
import Vue from 'vue'

import {nameToID} from '@/services/helper'

const state = () => ({
  container_id: localData.getlocalToken('container_id') || '',
  container_status: localData.getlocalToken('container_status') || '',
  reservation_data: { },
  actions : { },
  documents: [],
  availableDocuments: [],
  blockchain: '',
  alert_id: localData.getlocalToken('alert_id') || '',
  alert_type: localData.getlocalToken('alert_type') || '',
})

const mutations = {
  set_container_id(state, containerId){
    localData.setlocal('container_id',containerId)
    state.container_id = containerId 
  },
  set_container_status(state, containerStatus){
    localData.setlocal('container_status',containerStatus)
    state.container_status = containerStatus      
  },
  set_documents(state, [document, name, id, eventType]){
    state.documents[id] = {name: name, file : document, eventType : eventType}
  },
  set_availableDocuments(state, documents){
    state.availableDocuments = documents
  },
  clear_documents(state){
    state.documents = []
  },
  set_reservation_data(state, data){
    state.reservation_data = data
  },
  set_blockchain(state, blockchain){
    state.blockchain = blockchain
  },
  setStatus(state, accion){
    state.actions['stage' + accion.stage.id]['action_list']['action' + accion.id].status = accion.status
    state.actions['stage' + accion.stage.id]['action_list']['action' + accion.id].modified  = accion.modified
    state.actions['stage' + accion.stage.id]['action_list']['action' + accion.id].apiId  = accion.apiId
  },
  setDefaultActions(state, actions){
    state.actions = actions
  },
  setAlert(state, [id, type]){
    localData.setlocal('alert_id',id)
    state.alert_id = id
    localData.setlocal('alert_type',type)
    state.alert_type = type
  }
}

const actions = {
  async actionsUpdate({ commit }, acciones) {
    try {
      acciones.forEach(accion => {
        commit('setStatus',accion)
      });
      return 'OK'
    }catch (error) {
      console.log(error)
      return error
    }
  },
  resetDefaultActions({ commit }, actions) {
    commit('setDefaultActions', actions)
  }
}

const getters = {
  container_id: state => state.container_id,
  container_status: state => state.container_status,
  action_list: state => state.actions,
  documents: state => state.documents,
  availableDocuments: state => state.availableDocuments,
  reservation_data: state => state.reservation_data,
  blockchain: state => state.blockchain,
  alert_id: state => state.alert_id,
  alert_type: state => state.alert_type
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}